import './SignInForgotPassword.css'
import SignInNavBarBack from "components/layout/navigation/SignInNavBarBack/SignInNavBarBack";
import {useDispatch} from "react-redux";
import {updateSignUpScreen} from "store/ui/signUpScreen/signUpScreen.slice";
import BenevvTextField from "components/forms/BenevvTextField/BenevvTextField";
import {useState} from "react";
import BenevvSubmitField from "components/forms/BenevvSubmitField/BenevvSubmitField";
import {Slide} from "@mui/material";
import {GreyTextLight, RedTextBold} from "components/text/Text";

function SignInForgotPassword() {
  const dispatch = useDispatch();
  const [email, setEmail] = useState('');
  return (
    <div className={'sign-up-right-container'}>
      <SignInNavBarBack screen={'SignInScreen'}/>
      <Slide direction="left" in={true} mountOnEnter unmountOnExit>
        <div className={'sign-in-forgot-password'}>
          <div className={'sign-in-forgot-password-text'}>
            <h1> Forgot Password </h1>
            <div className={'remember-password'}>
              <GreyTextLight> Remember password?&nbsp;</GreyTextLight>
              <RedTextBold onClick={() => dispatch(updateSignUpScreen('SignInScreen'))}>Sign In</RedTextBold>
            </div>
            <p className={'please-enter-email-to-reset'}>
              Please enter your email address to reset your password. If an
              email address corresponds to one on file,
              we will send you a link to reset your password
            </p>
          </div>
          <form className={'forgot-password-form'}>
            <BenevvTextField htmlFor={'email'} labelText={'Email address*'} placeholder={'Enter email address'}
                             required={true} setTextField={setEmail}/>
            <BenevvSubmitField value={'Submit'}/>
          </form>
        </div>
      </Slide>
    </div>
  );
}

export default SignInForgotPassword;
